// import React, { Fragment, useState, useEffect } from "react";
// import ActionBar from "../TimeSlideTranscript/ActionBar";
// import _ from "lodash";
// import { navigate, useLocation } from "@reach/router";
// import styled from "styled-components";
// import themes from "../../../assets/theme";
// import COLORS from "../../../assets/Colors";
// import useLoader from "../../../hooks/useLoader";
// import CaseService from "../../../services/CaseService";
// import theme from "../../../assets/theme";
// import TranscriptEditor from "../../transcripts/TranscriptEditor/index";
// import AuthService from "../../../services/AuthService";
// import useUser from "../../../hooks/useUser";
// import TranscriptionService from "../../../services/TranscriptionService";
// import { Formik } from "formik";
// import {
//   Grid,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   makeStyles,
// } from "@material-ui/core";

// const useStyles = makeStyles((themes) => ({
//   formLabel: {
//     fontFamily: theme.fonts.primaryFontSemiBold,
//     color: COLORS.COLOR_DARK,
//   },
//   radioRoot: {
//     margin: 15,
//     [themes.breakpoints.up(640)]: {
//       margin: "0px 26px",
//     },
//     "& .MuiTab-root": {
//       padding: "5px 0",
//       [themes.breakpoints.up(640)]: {
//         padding: "6px 12px",
//       },
//     },
//     "& .MuiTab-wrapper": {
//       fontSize: 12,
//       [themes.breakpoints.up(640)]: {
//         fontSize: 16,
//       },
//     },
//   },
// }));

// const TranscriptEdit = (id) => {
//   const history = useLocation();
//   const queryParams = new URLSearchParams(history.search);
//   const typeValue = queryParams.get("caseType");
//   const classes = useStyles();
//   const { setLoader } = useLoader();
//   const [data, setData] = useState([
//     { id: "", start: "", end: "", text: "", speaker: "", confidence: "" },
//   ]);
//   const [mediaUrl, setMediaUrl] = useState();
//   const [meetingId, setMeetingId] = useState();
//   const [refreshDetails, setRefreshDetails] = useState(false);
//   const [render, setRender] = useState(false);
//   const { setToken } = useUser();
//   let LiveTranscription = true;
//   const [checked, setChecked] = useState(false);
//   const caseId = queryParams.get("meetingId");
//   const breadcrumbs = [
//     "Cases",
//     `${_.capitalize(typeValue)} - ${caseId}`,
//     "Transcript",
//   ];
//   const [caseTitle, setCaseTitle] = useState("");
//   const [trigger, setTrigger] = useState(false);
//   const [streamingKey, setStreaminKey] = useState();
//   const [meetingType, setMeetingType] = useState("plain");
//   const [triggerSocket, setTriggerSocket] = useState(true);

//   useEffect(() => {
//     async function validateToken() {
//       try {
//         const response = await AuthService.validateToken(caseId);
//         if (response?.expire) {
//           localStorage.removeItem("auth_token");
//           localStorage.removeItem("publicUrl");
//           setToken("");
//           navigate("/");
//         }
//         localStorage.setItem("auth_token", response.token);
//         localStorage.setItem("publicUrl", history.href);
//         setToken(response.token);
//         setCaseTitle(response?.title);
//         setRefreshDetails(true);
//       } catch (err) {
//         localStorage.removeItem("auth_token");
//         localStorage.removeItem("publicUrl");
//         setToken("");
//         navigate("/");
//       } finally {
//       }
//     }

//     validateToken();
//   }, []); // eslint-disable-line react-hooks/exhaustive-deps

//   useEffect(() => {
//     async function getLiveTranscriptionData(caseId) {
//       try {
//         setLoader({ state: true, message: "Fetching Transcription..." });
//         const response = await AuthService.validateToken(caseId);
//         if (response?.expire) {
//           localStorage.removeItem("auth_token");
//           localStorage.removeItem("publicUrl");
//           setToken("");
//           navigate("/");
//         }
//         const res = await CaseService.getLiveTranscriptionData(caseId);
//         const streamKey = await TranscriptionService.generateRTMPLink(
//           res?.meetingId,
//         );
//         if (streamKey?.streaming_key) {
//           setStreaminKey(streamKey?.streaming_key);
//         }
//         if (res && meetingType === "edited") {
//           setData(
//             res?.transcriptionData?.words?.map((el) => {
//               return {
//                 id: el?.id,
//                 end: el?.end,
//                 confidence: el?.confidence,
//                 text: el.text ? el?.text : "",
//                 start: el?.start,
//                 speaker: el?.speaker,
//               };
//             }),
//           );
//           setMeetingId(res?.meetingId);
//           setMediaUrl(res);
//         } else {
//           setMediaUrl();
//         }
//       } catch (error) {
//         console.log(error);
//       } finally {
//         setLoader({ state: false });
//         setRender(true);
//       }
//     }
//     if (refreshDetails) {
//       getLiveTranscriptionData(caseId);
//       setRefreshDetails(false);
//     }
//   }, [refreshDetails]); // eslint-disable-line react-hooks/exhaustive-deps

//   useEffect(() => {
//     async function getLiveTranscriptionData(caseId) {
//       try {
//         setLoader({ state: true, message: "Fetching Transcription..." });
//         const response = await AuthService.validateToken(caseId);
//         if (response?.expire) {
//           localStorage.removeItem("auth_token");
//           localStorage.removeItem("publicUrl");
//           setToken("");
//           navigate("/");
//         }
//         /*

//         const res = await TranscriptionService.liveTranscriptionSegments(
//           caseId
//         );
//         if (
//           Array.isArray(res?.transcriptionData) &&
//           res.transcriptionData.length > 0 &&
//           Array.isArray(res.transcriptionData[0]?.words)
//         ) {
//           setData(res.transcriptionData[0].words);
//           setMeetingId(res?.meetingId ?? null);
//           setMediaUrl(res);
//         } else {
//           setData([]);
//           setMeetingId(null);
//           setMediaUrl(null);
//         }

//         */
//         const res = await CaseService.getLiveTranscriptionData(caseId);
//         if (res.transcriptionData?.words.length > 0) {
//           setData(
//             res?.transcriptionData?.words?.map((el) => {
//               return {
//                 id: el?.id,
//                 end: el?.end,
//                 confidence: el?.confidence,
//                 text: el.text ? el?.text : "",
//                 start: el?.start,
//                 speaker: el?.speaker,
//               };
//             }),
//           );
//           setMeetingId(res?.meetingId ?? null);
//           setMediaUrl(res);
//         } else {
//           setData([]);
//           setMeetingId(null);
//           setMediaUrl(null);
//         }
//       } catch (error) {
//         console.log(error);
//       } finally {
//         setLoader({ state: false });
//         setRender(true);
//       }
//     }
//     if (triggerSocket) {
//       getLiveTranscriptionData(caseId);
//       setRefreshDetails(false);
//       setTriggerSocket(false);
//     }
//   }, [triggerSocket]); // eslint-disable-line react-hooks/exhaustive-deps

//   useEffect(() => {
//     if (checked) {
//       const timeInterval = setInterval(() => {
//         async function getLiveTranscriptionData(caseId) {
//           try {
//             setTrigger(true);
//             const response = await AuthService.validateToken(caseId);
//             if (response?.expire) {
//               localStorage.removeItem("auth_token");
//               localStorage.removeItem("publicUrl");
//               setToken("");
//               navigate("/");
//             }
//             const res = await CaseService.getLiveTranscriptionData(caseId);
//             if (res) {
//               setData(
//                 res?.transcriptionData?.words?.map((el) => {
//                   return {
//                     id: el?.id,
//                     end: el?.end,
//                     confidence: el?.confidence,
//                     text: el.text ? el?.text : "",
//                     start: el?.start,
//                     speaker: el?.speaker,
//                   };
//                 }),
//               );
//               setMeetingId(res?.meetingId);
//               setMediaUrl(res);
//             } else {
//               setMediaUrl();
//             }
//           } catch (error) {
//             console.log(error);
//           } finally {
//             setRender(true);
//             setTrigger(false);
//           }
//         }
//         getLiveTranscriptionData(caseId);
//       }, 1 * 1000);
//       return () => clearInterval(timeInterval);
//     }
//   }, [checked]); // eslint-disable-line react-hooks/exhaustive-deps

//   const actions = [
//     {
//       text: "Refresh",
//       props: {
//         onClick: () =>
//           meetingType === "plain"
//             ? setTriggerSocket(true)
//             : setRefreshDetails(true),
//       },
//       // hidden: false,
//       hidden: meetingType === "plain" ? true : false,
//     },
//   ];

//   const radio_inputs = [
//     {
//       label: "Raw Transcript",
//       name: "plain",
//       value: "plain",
//     },
//     {
//       label: "Edited Transcript",
//       name: "edited",
//       value: "edited",
//     },
//   ];

//   return (
//     <Fragment>
//       <ActionBar
//         {...{
//           breadcrumbs,
//           actions,
//           LiveTranscription,
//           checked,
//           setChecked,
//           meetingType,
//         }}
//       />
//       <Formik
//         initialValues={{
//           meetingType: "plain",
//         }}
//         enableReinitialize
//         validateOnBlur
//         validateOnChange
//         onSubmit={""}
//       >
//         {({
//           values,
//           handleChange,
//           errors,
//           handleSubmit,
//           touched,
//           setFieldValue,
//           setFieldError,
//           handleBlur,
//           isValid,
//           resetForm,
//         }) => (
//           <form>
//             <Grid
//               className={classes.radioRoot}
//               item
//               xs={12}
//               spacing={2}
//               style={{ marginTop: "5px", padding: 16 }}
//             >
//               <RadioGroup
//                 style={{
//                   flexDirection: "row",
//                   marginLeft: "10px",
//                 }}
//                 name={"meetingType"}
//                 value={values.meetingType}
//                 onChange={(e) => {
//                   const { value } = e.target;
//                   if (value === "edited") {
//                     setData([]);
//                     setRefreshDetails(true);
//                   } else {
//                     setChecked(false);
//                     setTriggerSocket(true);
//                     setData([
//                       {
//                         id: "",
//                         start: "",
//                         end: "",
//                         text: "",
//                         speaker: "",
//                         confidence: "",
//                       },
//                     ]);
//                   }
//                   setMeetingType(value);
//                   setFieldValue("meetingType", value);
//                 }}
//               >
//                 {radio_inputs.map((radio, key) => (
//                   <FormControlLabel
//                     {...{ key }}
//                     classes={{ label: classes.formLabel }}
//                     value={radio.value}
//                     control={
//                       <Radio size="medium" style={{ color: "#00838c" }} />
//                     }
//                     label={radio.label}
//                   />
//                 ))}
//               </RadioGroup>
//             </Grid>
//             <Container>
//               <div>
//                 {values?.meetingType === "edited" && !data ? (
//                   <StyledTableEmptyBlock>
//                     <h2>
//                       {" "}
//                       {
//                         "Welcome to JustAct live transcription services. Your session has either not started or your live transcript is currently being generated."
//                       }{" "}
//                     </h2>{" "}
//                   </StyledTableEmptyBlock>
//                 ) : (
//                   <TranscriptEditor
//                     {...{
//                       caseId,
//                       meetingId,
//                       data,
//                       refreshDetails,
//                       render,
//                       setRender,
//                       trigger,
//                       streamingKey,
//                       setData,
//                     }}
//                     mediaUrl={mediaUrl?.audioFileUrl}
//                     title={caseTitle}
//                     meetingType={values?.meetingType}
//                   />
//                 )}
//               </div>
//             </Container>
//           </form>
//         )}
//       </Formik>
//     </Fragment>
//   );
// };

// export default TranscriptEdit;

// export const Container = styled.div`
//   padding: 4px 43px;
//   display: flex;
//   flex-direction: column;
// `;

// export const HeadingContainer = styled.span`
//   margin-bottom: 31px;
//   font-family: ${themes.fonts.primaryFontSemiBold};
//   font-size: ${(props) => (props.size ? props.size : "13px")};
//   color: ${COLORS.BTN_GREEN};
//   // text-transform: uppercase;
//   cursor: pointer;
//   & .topSection {
//     background: ${COLORS.BOX_DARKGREEN};
//   }
// `;

// const StyledTableEmptyBlock = styled.div`
//   position: absolute;
//   top: 55%;
//   left: 55%;
//   transform: translate(-40%, -40%);
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   h2 {
//     color: ${COLORS.COLOR_DARK};
//     font-weight: 500;
//     letter-spacing: 0.1px;
//     font-size: 20px;
//     margin: 0;
//     text-align: center;
//     font-family: ${theme.fonts.primaryFontBold};
//   }
//   p {
//     margin: 10px auto 30px;
//     font-family: ${theme.fonts.primaryFontRegular};
//     color: ${COLORS.COLOR_DARK};
//   }
//   a {
//     color: ${COLORS.BTN_GREEN};
//     font-family: ${theme.fonts.primaryFontRegular};
//   }
// `;









import React, { Fragment, useState, useEffect } from "react";
import ActionBar from "../TimeSlideTranscript/ActionBar";
import _ from "lodash";
import { navigate, useLocation } from "@reach/router";
import styled from "styled-components";
import themes from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import useLoader from "../../../hooks/useLoader";
import CaseService from "../../../services/CaseService";
import theme from "../../../assets/theme";
import TranscriptEditor from "../../transcripts/TranscriptEditor/index";
import AuthService from "../../../services/AuthService";
import useUser from "../../../hooks/useUser";
import TranscriptionService from "../../../services/TranscriptionService";
import { Formik } from "formik";

import {
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((themes) => ({
  formLabel: {
    fontFamily: theme.fonts.primaryFontSemiBold,
    color: COLORS.COLOR_DARK,
  },
  radioRoot: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "0px 26px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },
}));

const TranscriptEdit = (id) => {
  const history = useLocation();
  const queryParams = new URLSearchParams(history.search);
  const typeValue = queryParams.get("caseType");
  const classes = useStyles();
  const { setLoader } = useLoader();
  const [data, setData] = useState([
    { id: "", start: "", end: "", text: "", speaker: "", confidence: "" },
  ]);
  const [mediaUrl, setMediaUrl] = useState();
  const [meetingId, setMeetingId] = useState();
  const [refreshDetails, setRefreshDetails] = useState(false);
  const [render, setRender] = useState(false);
  const { setToken } = useUser();
  let LiveTranscription = true;
  const [checked, setChecked] = useState(false);
  const caseId = queryParams.get("meetingId");
  const breadcrumbs = [
    "Cases",
    `${_.capitalize(typeValue)} - ${caseId}`,
    "Transcript",
  ];
  const [caseTitle, setCaseTitle] = useState("");
  const [trigger, setTrigger] = useState(false);
  const [streamingKey, setStreaminKey] = useState();
  const [meetingType, setMeetingType] = useState("plain");
  const [triggerSocket, setTriggerSocket] = useState(true);

  useEffect(() => {
    async function validateToken() {
      try {
        const response = await AuthService.validateToken(caseId);
        if (response?.expire) {
          localStorage.removeItem("auth_token");
          localStorage.removeItem("publicUrl");
          setToken("");
          navigate("/");
        }
        localStorage.setItem("auth_token", response.token);
        localStorage.setItem("publicUrl", history.href);
        setToken(response.token);
        setCaseTitle(response?.title);
        setRefreshDetails(true);
      } catch (err) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("publicUrl");
        setToken("");
        navigate("/");
      } finally {
      }
    }

    validateToken();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    async function getLiveTranscriptionData(caseId) {
      try {
        setLoader({ state: true, message: "Fetching Transcription..." });
        const response = await AuthService.validateToken(caseId);
        if (response?.expire) {
          localStorage.removeItem("auth_token");
          localStorage.removeItem("publicUrl");
          setToken("");
          navigate("/");
        }
        const res = await CaseService.getLiveTranscriptionData(caseId);
        const streamKey = await TranscriptionService.generateRTMPLink(
          res?.meetingId,
        );
        if (streamKey?.streaming_key) {
          setStreaminKey(streamKey?.streaming_key);
        }
        if (res && meetingType === "edited") {
          setData(
            res?.transcriptionData?.words?.map((el) => {
              return {
                id: el?.id,
                end: el?.end,
                confidence: el?.confidence,
                text: el.text ? el?.text : "",
                start: el?.start,
                speaker: el?.speaker,
              };
            }),
          );
          setMeetingId(res?.meetingId);
          setMediaUrl(res);
        } else {
          setMediaUrl();
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoader({ state: false });
        setRender(true);
      }
    }
    if (refreshDetails) {
      getLiveTranscriptionData(caseId);
      setRefreshDetails(false);
    }
  }, [refreshDetails]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    async function getLiveTranscriptionData(caseId) {
      try {
        setLoader({ state: true, message: "Fetching Transcription..." });
        const response = await AuthService.validateToken(caseId);
        if (response?.expire) {
          localStorage.removeItem("auth_token");
          localStorage.removeItem("publicUrl");
          setToken("");
          navigate("/");
        }
        /*

        const res = await TranscriptionService.liveTranscriptionSegments(
          caseId
        );
        if (
          Array.isArray(res?.transcriptionData) &&
          res.transcriptionData.length > 0 &&
          Array.isArray(res.transcriptionData[0]?.words)
        ) {
          setData(res.transcriptionData[0].words);
          setMeetingId(res?.meetingId ?? null);
          setMediaUrl(res);
        } else {
          setData([]);
          setMeetingId(null);
          setMediaUrl(null);
        }

        */
        const res = await CaseService.getLiveTranscriptionData(caseId);
        if (res.transcriptionData?.words.length > 0) {
          setData(
            res?.transcriptionData?.words?.map((el) => {
              return {
                id: el?.id,
                end: el?.end,
                confidence: el?.confidence,
                text: el.text ? el?.text : "",
                start: el?.start,
                speaker: el?.speaker,
              };
            }),
          );
          setMeetingId(res?.meetingId ?? null);
          setMediaUrl(res);
        } else {
          setData([]);
          setMeetingId(null);
          setMediaUrl(null);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoader({ state: false });
        setRender(true);
      }
    }
    if (triggerSocket) {
      getLiveTranscriptionData(caseId);
      setRefreshDetails(false);
      setTriggerSocket(false);
    }
  }, [triggerSocket]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (checked) {
      const timeInterval = setInterval(() => {
        async function getLiveTranscriptionData(caseId) {
          try {
            setTrigger(true);
            const response = await AuthService.validateToken(caseId);
            if (response?.expire) {
              localStorage.removeItem("auth_token");
              localStorage.removeItem("publicUrl");
              setToken("");
              navigate("/");
            }
            const res = await CaseService.getLiveTranscriptionData(caseId);
            if (res) {
              setData(
                res?.transcriptionData?.words?.map((el) => {
                  return {
                    id: el?.id,
                    end: el?.end,
                    confidence: el?.confidence,
                    text: el.text ? el?.text : "",
                    start: el?.start,
                    speaker: el?.speaker,
                  };
                }),
              );
              setMeetingId(res?.meetingId);
              setMediaUrl(res);
            } else {
              setMediaUrl();
            }
          } catch (error) {
            console.log(error);
          } finally {
            setRender(true);
            setTrigger(false);
          }
        }
        getLiveTranscriptionData(caseId);
      }, 1 * 1000);
      return () => clearInterval(timeInterval);
    }
  }, [checked]); // eslint-disable-line react-hooks/exhaustive-deps

  const actions = [
    {
      text: "Refresh",
      props: {
        onClick: () =>
          meetingType === "plain"
            ? setTriggerSocket(true)
            : setRefreshDetails(true),
      },
      // hidden: false,
      hidden: meetingType === "plain" ? true : false,
    },
  ];

  const radio_inputs = [
    {
      label: "Raw Transcript",
      name: "plain",
      value: "plain",
    },
    {
      label: "Edited Transcript",
      name: "edited",
      value: "edited",
    },
  ];

  return (
    <Fragment>
      <ActionBar
        {...{
          breadcrumbs,
          actions,
          LiveTranscription,
          checked,
          setChecked,
          meetingType,
        }}
      />
      <Formik
        initialValues={{
          meetingType: "plain",
        }}
        enableReinitialize
        validateOnBlur
        validateOnChange
        onSubmit={""}
      >
        {({
          values,
          handleChange,
          errors,
          handleSubmit,
          touched,
          setFieldValue,
          setFieldError,
          handleBlur,
          isValid,
          resetForm,
        }) => (
          <form>
            <Grid
              className={classes.radioRoot}
              item
              xs={12}
              spacing={2}
              style={{ marginTop: "5px", padding: 16 }}
            >
              <RadioGroup
                style={{
                  flexDirection: "row",
                  marginLeft: "10px",
                }}
                name={"meetingType"}
                value={values.meetingType}
                onChange={(e) => {
                  const { value } = e.target;
                  if (value === "edited") {
                    setData([]);
                    setRefreshDetails(true);
                  } else {
                    setChecked(false);
                    setTriggerSocket(true);
                    setData([
                      {
                        id: "",
                        start: "",
                        end: "",
                        text: "",
                        speaker: "",
                        confidence: "",
                      },
                    ]);
                  }
                  setMeetingType(value);
                  setFieldValue("meetingType", value);
                }}
              >
                {radio_inputs.map((radio, key) => (
                  <FormControlLabel
                    {...{ key }}
                    classes={{ label: classes.formLabel }}
                    value={radio.value}
                    control={
                      <Radio size="medium" style={{ color: "#00838c" }} />
                    }
                    label={radio.label}
                  />
                ))}
              </RadioGroup>
            </Grid>
            <Container>
              <div>
                {values?.meetingType === "edited" && !data ? (
                  <StyledTableEmptyBlock>
                    <h2>
                      {" "}
                      {
                        "Welcome to JustAct live transcription services. Your session has either not started or your live transcript is currently being generated."
                      }{" "}
                    </h2>{" "}
                  </StyledTableEmptyBlock>
                ) : (
                  <TranscriptEditor
                    {...{
                      caseId,
                      meetingId,
                      data,
                      refreshDetails,
                      render,
                      setRender,
                      trigger,
                      streamingKey,
                      setData,
                    }}
                    mediaUrl={mediaUrl?.audioFileUrl}
                    title={caseTitle}
                    meetingType={values?.meetingType}
                  />
                )}
              </div>
            </Container>
          </form>
        )}
      </Formik>
    </Fragment>
  );
};

export default TranscriptEdit;

export const Container = styled.div`
  padding: 4px 43px;
  display: flex;
  flex-direction: column;
`;

export const HeadingContainer = styled.span`
  margin-bottom: 31px;
  font-family: ${themes.fonts.primaryFontSemiBold};
  font-size: ${(props) => (props.size ? props.size : "13px")};
  color: ${COLORS.BTN_GREEN};
  // text-transform: uppercase;
  cursor: pointer;
  & .topSection {
    background: ${COLORS.BOX_DARKGREEN};
  }
`;

const StyledTableEmptyBlock = styled.div`
  position: absolute;
  top: 55%;
  left: 55%;
  transform: translate(-40%, -40%);
  display: flex;
  flex-direction: column;
  align-items: center;
  h2 {
    color: ${COLORS.COLOR_DARK};
    font-weight: 500;
    letter-spacing: 0.1px;
    font-size: 20px;
    margin: 0;
    text-align: center;
    font-family: ${theme.fonts.primaryFontBold};
  }
  p {
    margin: 10px auto 30px;
    font-family: ${theme.fonts.primaryFontRegular};
    color: ${COLORS.COLOR_DARK};
  }
  a {
    color: ${COLORS.BTN_GREEN};
    font-family: ${theme.fonts.primaryFontRegular};
  }
`;
